import { COAST_AREA } from '@/data/maps/coast';
import { COTTAGE_AREA } from '@/data/maps/cottage';
import { FARM_AREA } from '@/data/maps/farm';
import { Area, type AreaDefinition, type AuthoredAreaId } from '@/world/area';

/** Every place in the world. Adding one is a definition plus an entry here. */
export const AREA_DEFINITIONS: Readonly<Record<AuthoredAreaId, AreaDefinition>> = {
  farm: FARM_AREA,
  cottage: COTTAGE_AREA,
  coast: COAST_AREA,
};

export const STARTING_AREA: AuthoredAreaId = 'farm';

/**
 * Areas are built once and reused.
 *
 * Rebuilding on every transition would re-parse the tilemap each time the
 * player steps through a door, and would throw away any per-area state added
 * later — crop growth, dropped items, an NPC mid-route.
 */
const cache = new Map<AuthoredAreaId, Area>();

export function getArea(id: AuthoredAreaId): Area {
  let area = cache.get(id);
  if (!area) {
    area = new Area(AREA_DEFINITIONS[id]);
    cache.set(id, area);
  }
  return area;
}

/** True only for authored places, which is what a save may name. */
export function isAreaId(value: unknown): value is AuthoredAreaId {
  return typeof value === 'string' && value in AREA_DEFINITIONS;
}
